import { forwardRef } from "react";
import { ScanBarcode, Loader2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";

export const EanInput = forwardRef(function EanInput({
  value,
  onChange,
  onSubmit,
  loading,
  disabled,
  onCameraClick,
  showCameraButton,
}, ref) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && value.trim()) {
      onSubmit();
    }
  };

  return (
    <Card className={disabled ? "opacity-60" : "border-primary/30"}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between mb-4">
          <span className="text-sm font-medium uppercase tracking-wider text-muted-foreground">
            Skanna produkt
          </span>
          {showCameraButton && onCameraClick && (
            <Button
              variant="outline"
              size="sm"
              onClick={onCameraClick}
              className="gap-2"
              data-testid="camera-toggle-btn"
            >
              <ScanBarcode className="h-4 w-4" />
              <span className="hidden sm:inline">Kamera</span>
            </Button>
          )}
        </div>
        
        <div className="flex gap-2">
          <div className="relative flex-1">
            <ScanBarcode className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
            <Input
              ref={ref}
              type="text"
              inputMode="numeric"
              placeholder="Skanna eller ange EAN-kod"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              onKeyDown={handleKeyDown}
              className="pl-10 h-12 text-lg font-mono"
              disabled={disabled}
              data-testid="ean-input"
            />
          </div>
          <Button
            onClick={onSubmit}
            disabled={disabled || loading || !value.trim()}
            className="h-12 px-6"
            data-testid="ean-submit"
          >
            {loading ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
              <ArrowRight className="h-5 w-5" />
            )}
          </Button>
        </div>
        
        <p className="text-xs text-muted-foreground mt-2">
          Använd Zebra-skanner eller skriv in EAN-kod manuellt
        </p>
      </CardContent>
    </Card>
  );
});
